import { ArrowRight } from "lucide-react";

/**
 * Anonymized engagement story.
 * Replace the SITUATION / FINDINGS / FIX / OUTCOME copy with real
 * (or further anonymized) numbers from a recent engagement.
 */
export default function ArqEngagementStory() {
  return (
    <section className="bg-arq-bg py-20 md:py-[100px] px-6 border-t border-arq-border/60">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center max-w-[820px] mx-auto mb-12">
          <div className="arq-label mb-6">A Recent Engagement</div>
          <h2
            className="font-display font-semibold text-arq-text mb-5"
            style={{ fontSize: "clamp(28px, 4vw, 40px)", lineHeight: 1.2 }}
          >
            What an Assessment Looks Like in Practice.
          </h2>
          <p className="text-arq-muted text-[17px] leading-[1.75]">
            Anonymized. Numbers and timeline are real.
          </p>
        </div>

        <div className="arq-card p-8 md:p-10">
          <div className="grid md:grid-cols-4 gap-8 md:gap-6">
            {/* Situation */}
            <div>
              <div className="font-mono-tech text-[11px] text-arq-blue tracking-[0.08em] mb-3">
                01 · SITUATION
              </div>
              <p className="text-arq-text text-[15px] leading-[1.7]">
                Series B fintech, 180 employees, pre-SOC 2. Deploying agentic
                AI for underwriting workflows. Enterprise buyer required
                documented AI risk posture before signing.
              </p>
            </div>

            {/* Findings */}
            <div>
              <div className="font-mono-tech text-[11px] text-arq-blue tracking-[0.08em] mb-3">
                02 · WHAT WE FOUND
              </div>
              <ul className="space-y-2 text-arq-text text-[14px] leading-[1.6]">
                <li className="flex gap-2">
                  <span className="text-arq-danger font-mono">●</span>
                  <span>2 critical: agent authorization bypass, prompt injection to tool-use</span>
                </li>
                <li className="flex gap-2">
                  <span className="font-mono" style={{ color: "#D97706" }}>●</span>
                  <span>6 high: API authz gaps, secrets in agent runtime</span>
                </li>
                <li className="flex gap-2">
                  <span className="text-arq-teal font-mono">●</span>
                  <span>11 medium: consent enforcement, audit logging</span>
                </li>
              </ul>
            </div>

            {/* Fix */}
            <div>
              <div className="font-mono-tech text-[11px] text-arq-blue tracking-[0.08em] mb-3">
                03 · WHAT WE FIXED
              </div>
              <p className="text-arq-text text-[15px] leading-[1.7]">
                Re-architected agent authorization boundaries. Added human
                approval gates on financial actions. Closed application-layer
                authz gaps. Validated controls in production with adversarial
                regression tests.
              </p>
            </div>

            {/* Outcome */}
            <div>
              <div className="font-mono-tech text-[11px] text-arq-teal tracking-[0.08em] mb-3">
                04 · OUTCOME
              </div>
              <ul className="space-y-3 text-arq-text text-[15px] leading-[1.6]">
                <li>
                  <span className="font-display text-[22px] font-semibold text-arq-text block">
                    9 weeks
                  </span>
                  <span className="text-arq-muted text-[13px]">
                    assessment to validated remediation
                  </span>
                </li>
                <li>
                  <span className="font-display text-[22px] font-semibold text-arq-teal block">
                    $4.2M deal signed
                  </span>
                  <span className="text-arq-muted text-[13px]">
                    enterprise contract unblocked by documented AI risk posture
                  </span>
                </li>
                <li>
                  <span className="font-display text-[22px] font-semibold text-arq-text block">
                    SOC 2 Type I
                  </span>
                  <span className="text-arq-muted text-[13px]">
                    achieved without re-scoping
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-10 pt-6 border-t border-arq-border flex flex-col md:flex-row md:items-center md:justify-between gap-4">
            <p className="text-arq-muted text-[14px] italic">
              Every engagement ships with reproduction steps, regulatory
              mapping, and a remediation path.
            </p>
            <a
              href="#contact"
              className="inline-flex items-center gap-2 text-arq-blue text-[14px] font-semibold hover:text-arq-blue-bright transition-colors"
            >
              Discuss your environment <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
